import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { sortBy } from "lodash";
import moment from "moment";
import { getSessionAISummary } from "../../../../actions/sessionDetailAction";
import { useDispatch, useSelector } from "react-redux";
import NoAISummaryAvailableView from "./NoAISummaryAvailableView";
import SummaryDataBox from "./SummaryDataBox";
import PrepareAISummaryView from "./PrepareAISummaryView";
import PendingAISummaryBannerView from "./PendingAISummaryBannerView";
import { Localize } from "../Localize";
import { FULL_DATE_FORMAT } from "../../../../constants/Constants";

let startTimeStamp = null;

const AISummaryTab = ({ meetingID }) => {
    const dispatch = useDispatch();
    const { getSessionAISummaryData, getSessionAISummaryLoading } = useSelector(
        (state) => state.sessionDetail
    );
    const { selectedlanguage } = useSelector((state) => state.language);

    const [summaryData, setSummaryData] = useState([]);
    const [summaryDataLoaing, setSummaryDataLoaing] = useState(true);
    const [localisedValues, setLocalisedValues] = useState({});

    useEffect(() => {
        if (selectedlanguage?.id) {
            setLocalisedValues(Localize[selectedlanguage.id]);
        }
    }, [selectedlanguage]);

    useEffect(() => {
        dispatch(getSessionAISummary({ sessionId: meetingID }));
        const mainDiv = document.getElementById("session-ai-summary");
        if (mainDiv) {
            mainDiv.classList.add("active", "show");
        }
        return () => {
            mainDiv.classList.remove("active", "show");
        };
    }, []);

    // Function to fetch and parse TXT file as JSON
    async function fetchJsonFromTxt(url) {
        try {
            const response = await fetch(url);
            const text = await response.text(); // get text content
            return JSON.parse(text); // parse text as JSON
        } catch (error) {
            console.error("Error fetching/parsing JSON from:", url, error);
            return null;
        }
    }

    // Main function to get all JSON data
    async function getAllSessionData(sessionFiles) {
        const results = await Promise.all(
            sessionFiles?.map(async (file) => {
                const [transcriptionJson, aiSummaryJson] = await Promise.all([
                    fetchJsonFromTxt(file.transcription?.fileUrl || ""),
                    fetchJsonFromTxt(file.aiSummary?.fileUrl || ""),
                ]);

                return {
                    sessionStartTime: file.sessionStartTime || "",
                    duration: file.duration || "00:00",
                    transcription: transcriptionJson,
                    aiSummary: {
                        ...aiSummaryJson,
                        fileName: file.aiSummary?.fileName || ""
                    },
                    fileName: file.transcription?.fileName || ""
                };
            })
        );

        return results;
    }

    useEffect(() => {
        const sessionSummaryFiles =
            getSessionAISummaryData?.data?.sessionSummaryFiles || [];
        if (sessionSummaryFiles?.length > 0) {
            getAllSessionData(sessionSummaryFiles).then((data) => {
                setSummaryData(data);
                setSummaryDataLoaing(false);
                console.log("All parsed session data:", data);
            }).catch((err) => {
                setSummaryDataLoaing(false);
                console.error("All parsed session data err:", err);
            });
        } else if (getSessionAISummaryData) {
            setSummaryDataLoaing(false);
        }
    }, [getSessionAISummaryData]);

    console.log("summaryData__AIIIIIIISummaryTab", summaryData);

    return (
        <div
            className="tab-pane fade ai-summary-tab-pane"
            id="session-ai-summary"
            role="tabpanel"
            aria-labelledby="session-ai-summary-tab"
            tabIndex={0}
        >
            {(getSessionAISummaryLoading || summaryDataLoaing) &&
                <div className="no-session-data custom-scroll-div">
                    <div className="no-session-data-in">
                        <div className="no-session-data-box">
                            <p>{localisedValues?.loading_ai_summary}</p>
                        </div>
                    </div>
                </div>
            }
            {(getSessionAISummaryData.data?.sessionSummaryFiles?.length === 0 && getSessionAISummaryData?.data?.pendingSummaryCount === 0) && (
                <NoAISummaryAvailableView localisedValues={localisedValues} />
            )}
            {(getSessionAISummaryData?.data?.availableSummaryCount === 0 &&
                getSessionAISummaryData?.data?.pendingSummaryCount > 0) &&
                <PrepareAISummaryView localisedValues={localisedValues} />
            }
            {summaryData.length > 0 && (
                <div className="session-ai-summary">
                    {(getSessionAISummaryData?.data?.availableSummaryCount > 0 &&
                        getSessionAISummaryData?.data?.pendingSummaryCount > 0) &&
                        <PendingAISummaryBannerView localisedValues={localisedValues} count={getSessionAISummaryData?.data?.pendingSummaryCount} />
                    }
                    <div className="session-ai-summary-in custom-scroll-div">
                        <div className="accordion" id="aisummarynaccordion">
                            {sortBy(summaryData, summary => -moment(summary.sessionStartTime, FULL_DATE_FORMAT)?.toDate()?.getTime())?.map((summary, index) => (
                                <SummaryDataBox
                                    key={summary.sessionStartTime + summary.duration}
                                    index={index}
                                    summary={summary}
                                    summaryDataLength={summaryData.length}
                                    localisedValues={localisedValues}
                                    startTimeStamp={startTimeStamp}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

AISummaryTab.propTypes = {
    meetingID: PropTypes.any,
};

export default AISummaryTab;
